/* eslint-disable camelcase */
import { bookLiveClass } from '@common/vanilla_ui/forms/bookLiveClass';
import {
  PhoneInput, FormFlow, Form, Select,
} from '@common/vanilla_ui/general';
import gtmTracking from '@common/vanilla_ui/tracking/gtm';
import { ResendOtpForm } from '@common/vanilla_ui/forms';
import { OtpForm, RegisterForm } from '@common/vanilla_ui/forms/handlers';
import Toastify from 'toastify-js';
import {
  getAttribution,
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import registrationTracking from './registrationTracking';
import { INTENTS, PROGRAMS } from '@common/vanilla_ui/tracking/constants';

let loggedIn = false;
let phoneVerified = false;
const formId = 'marketing-form';
const positionFieldId = 'marketing-form-otp-position';
const DEFAULT_HEADER = 'Free Career Counselling is just a call away!';
const OTP_FORM_HEADER = 'Request a callback';
const PROGRAMS_MAPPING = {
  academy: 'academy',
  'data-science': 'data_science',
  ai_ml: 'ai_ml',
};

const setFormAttribution = (program) => {
  let attributionProgram = PROGRAMS.DATA_SCIENCE;
  if (program === 'academy') {
    attributionProgram = PROGRAMS.SOFTWARE_DEVELOPMENT;
  }
  if (program === 'ai_ml') {
    attributionProgram = PROGRAMS.AI_ML;
  }
  setAttribution(
    INTENTS.RCB_FORM,
    {
      program: attributionProgram,
    },
  );

  return getAttribution();
};

const track = (eventName, eventType = 'click', value = null) => {
  if (window.storeEsEvent) {
    window.storeEsEvent(
      `course-landing-marketing-form-${eventName}`, eventType, value,
    );
  }
};

const getPayload = (values) => {
  const programEl = document.querySelector('div[data-program]');
  const program = programEl ? programEl.getAttribute(
    'data-program',
  ) : 'academy';

  const {
    email,
    phone_number,
    otp,
  } = values;
  return {
    user: {
      email,
      phone_number,
      otp,
      skip_existing_user_check: true,
      program,
      rcb_prams: {
        attributions: setFormAttribution(program),
      },
    },
    type: 'course_landing',
    source: 'Course page',
  };
};

const initializeOtpFormInputs = () => {
  new PhoneInput('marketing-form__phone');
};

const initializeRegisterFormInputs = () => {
  if (!phoneVerified) {
    new PhoneInput('marketing-form-submit__phone');
  }
};

const setupMainForm = () => {
  const otpInput = document.getElementById(`${formId}__otp`);
  const otpFormEl = document.getElementById(`${formId}-otp`);
  const submitFormEl = document.getElementById(`${formId}-submit`);
  const resendOtpFormEl = document.querySelector(`.${formId}__otp-hint`);
  const formEl = document.getElementById(formId);
  const titleElement = formEl.querySelector('.section-header__title');
  const floatingBtnEl = document.querySelector('.floating-btn');

  const form = new FormFlow(
    'marketing-form', 'marketing-form', 'page', 'register',
  );

  const updateHeaderTitle = (newTitle = DEFAULT_HEADER) => {
    if (titleElement) {
      titleElement.textContent = newTitle;
    }
  };

  const formFlowEl = document.querySelector('#marketing-form');
  loggedIn = formFlowEl.getAttribute('data-logged-in') === 'true';
  phoneVerified = formFlowEl.getAttribute('data-phone-verified') === 'true';

  const programEl = document.querySelector('div[data-program]');
  const program = programEl ? programEl.getAttribute(
    'data-program',
  ) : 'academy';

  const positionFieldEl = document.getElementById(positionFieldId);
  if (positionFieldEl) {
    new Select(positionFieldId);
  }

  registrationTracking.initialize();

  if (floatingBtnEl) {
    floatingBtnEl.addEventListener('click', () => {
      formFlowEl.scrollIntoView({
        behavior: 'smooth',
        top: 10,
      });
    });
  }

  form.setFormHandler('register', element => {
    const { otpMsgForm, otpVoiceForm } = ResendOtpForm.initialize(
      'marketing-form', track,
    );
    const endpoint = phoneVerified
      ? '/users/v2/' : '/users/v2/account/verify';

    const registerForm = new Form(element, {
      method: 'POST',
      endpoint: loggedIn ? endpoint : '/users/v2/verify',
      createPayload: getPayload,
    });

    const otpFormId = 'marketing-form-otp';
    const otpForm = new Form(
      document.getElementById(otpFormId),
      {
        method: loggedIn ? 'PUT' : 'POST',
        endpoint: loggedIn ? '/users/v2/account' : '/users/v2/',
        createPayload: values => ({
          user: {
            ...values,
            program,
            skip_existing_user_check: true,
          },
          type: 'marketing',
          source: 'Course page',
          account_type: PROGRAMS_MAPPING[program] || 'data_science',
          'cf-turnstile-response': values['cf-turnstile-response'],
        }),
        validations: {
          phone_number: 'mobile',
          orgyear: 'required',
          email: 'email',
        },
      },
    );

    otpForm.addEventListener('invalidfields', (errors) => {
      const errorMessage = errors[Object.keys(errors)[0]];
      Toastify({
        text: errorMessage,
        className: 'toastify-danger',
      }).showToast();
    });

    const otpFormSubmittedCb = () => {
      const submitFormId = 'marketing-form-submit';
      const phoneNumberVal = otpForm.getFieldValue('phone_number');
      if (phoneNumberVal) {
        const phoneNumberArr = phoneNumberVal.split('-');
        const countryCode = phoneNumberArr[0];
        const phoneNumber = phoneNumberArr[1];
        const countryCodeEl = document.getElementById(
          `input-${submitFormId}__phone-code`,
        );
        const phoneNumberEl = document.getElementById(
          `${submitFormId}__phone-number`,
        );
        countryCodeEl.value = countryCode;
        phoneNumberEl.value = phoneNumber;
      }
    };

    const enableOtpForm = () => {
      otpFormEl.classList.add('hidden');
      submitFormEl.classList.remove('hidden');
      resendOtpFormEl.classList.remove('hidden');
      updateHeaderTitle(OTP_FORM_HEADER);
    };

    OtpForm.initialize({
      registerForm,
      otpVoiceForm,
      otpMsgForm,
      initializeInputs: initializeOtpFormInputs,
      parentFormId: formId,
      formId: 'marketing-form-otp',
      track,
      otpForm,
      submittedCallback: otpFormSubmittedCb,
      enableOtpForm,
    });

    const registerFormSubmitCb = () => {
      if (!phoneVerified) {
        registerForm.updateField(
          'otp', otpInput.value,
        );
      }
    };

    const registerFormSubmittedCb = () => {
      gtmTracking.sendFormSubmitStatus('marketing-form-submit', true);
      bookLiveClass(program);
      if (!phoneVerified) {
        registerForm.setDisabled(true);
        track(
          'register-step-complete', 'click',
          registerForm.getFieldValue('email'),
        );
      }
      track('open-dashboard', 'click');
    };

    RegisterForm.initialize({
      registerForm,
      formId,
      initializeInputs: initializeRegisterFormInputs,
      submitCallback: registerFormSubmitCb,
      submittedCallback: registerFormSubmittedCb,
    });
  });
  form.initialize();
};

const initialize = () => {
  const formEl = document.getElementById(formId);
  if (formEl) {
    setupMainForm();
  }
};

export default { initialize };
